import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, Icon } from 'sd-ui-components';

const BackBreadcumb = props => (
  <Breadcrumb className="app-layout-breadcrumb">
    <Breadcrumb.Item className="app-layout-breadcrumb-item sd-primary-color-1">
      <Icon icon="arrow-left" size={16} className="app-layout-arrow-icon" />
      &nbsp;
      <Link to={props.to} className="app-layout-breadcrumb-link">
        {props.children}
      </Link>
    </Breadcrumb.Item>
  </Breadcrumb>
);

export default BackBreadcumb;



// WEBPACK FOOTER //
// ./src/containers/Common/BackBreadcrumb.jsx